export default __webpack_public_path__ + "static/media/about.b8b154b4.jpg";